import React from 'react';
import { Typography } from '@mui/material';
import { SwapHoriz } from '@mui/icons-material';
import { ShiftSegmentTypeName } from '../../../Enums';
import { getAsLongDate, getAsStartAndEndTimeFormat, formatDateRange } from '../../../../common-client2/src/services/ukgDateTime';

/**
 * @typedef {{ qualifier: string, id: number }} OrgJobRef
 * @typedef {{ type: string, orgJobRef: OrgJobRef }} Segment
 * @typedef {{ startDate: string, endDate: string, id: number, segments: Segment[] }} Shift
 * @param {{ shift: Shift }} props
 */
const ProposableShiftDateTime = ({ shift }) => {
    const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
    return (
        <div className="psd-container">
            <Typography
                variant="subtitle2"
                className="date"
            >
                {getAsLongDate(shift.startDateTime)}
            </Typography>
            <Typography variant="subtitle2">
                {`${shift.label ?? ""} ${getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}`}
            </Typography>
            {transferSegment && <SwapHoriz className="icon" />}
        </div>
    )
}

export default ProposableShiftDateTime